import { render, staticRenderFns } from "./histogramJhhCourse.vue?vue&type=template&id=762e28c5&scoped=true"
import script from "./histogramJhhCourse.vue?vue&type=script&lang=js"
export * from "./histogramJhhCourse.vue?vue&type=script&lang=js"
import style0 from "./histogramJhhCourse.vue?vue&type=style&index=0&id=762e28c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762e28c5",
  null
  
)

export default component.exports